var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBurgerMenuClose = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.9163L9.29278 24.6236C9.04183 24.8745 8.72243 25 8.3346 25C7.94677 25 7.62738 24.8745 7.37643 24.6236C7.12548 24.3726 7 24.0532 7 23.6654C7 23.2776 7.12548 22.9582 7.37643 22.7072L14.0837 16L7.37643 9.29278C7.12548 9.04183 7 8.72243 7 8.3346C7 7.94677 7.12548 7.62738 7.37643 7.37643C7.62738 7.12548 7.94677 7 8.3346 7C8.72243 7 9.04183 7.12548 9.29278 7.37643L16 14.0837L22.7072 7.37643C22.9582 7.12548 23.2776 7 23.6654 7C24.0532 7 24.3726 7.12548 24.6236 7.37643C24.8745 7.62738 25 7.94677 25 8.3346C25 8.72243 24.8745 9.04183 24.6236 9.29278L17.9163 16L24.6236 22.7072C24.8745 22.9582 25 23.2776 25 23.6654C25 24.0532 24.8745 24.3726 24.6236 24.6236C24.3726 24.8745 24.0532 25 23.6654 25C23.2776 25 22.9582 24.8745 22.7072 24.6236L16 17.9163Z",
    fill: "#242424"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBurgerMenuClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/burger-menu-close.6b8b92e5a351fb4a7b9a0f39ed1b76b3.svg";